<template>
  <div :class="`as-performance ${modifyClass}`">
    <div class="as-performance__head">
      <IconPerformance />
      <span> Phong độ - Đội nào sẽ dành chiến thắng? </span>
    </div>
    <div class="as-performance__body">
      <FootballTeamItem
        :footyStats="footyStats"
        :match="match"
        modifyClass="as-vertical"
        :showName="false"
        :homePoint="homePoint"
        :awayPoint="awayPoint"
      />
      <div class="as-vs">
        <div class="as-vs__tile">Phong độ tổng quan</div>
        <div class="as-vs__line">
          <div class="as-vs-line-item">
            <div class="as-vs-line-item__main"></div>
            <div class="as-vs-line-item__percent"></div>
            <div class="as-vs-line-item__ball">
              <div class="as-icon">
                <IBall />
              </div>
            </div>
          </div>
        </div>
        <div v-if="homePoint > 0 || awayPoint > 0" class="as-vs__text">
          <span class="as-bold">{{ homePoint > awayPoint ? footyStats?.home_name : footyStats?.away_name }}</span> có
          <span class="as-green">{{ getPercentByPoint(homePoint, awayPoint) }}%</span> tốt hơn xét về<br />
          <span class="as-bold">Điểm số mỗi trận đấu</span>
        </div>
      </div>
      <FootballTeamItem
        :footyStats="footyStats"
        :match="match"
        modeTeam="as-away"
        modifyClass="as-vertical"
        :showName="false"
        :homePoint="homePoint"
        :awayPoint="awayPoint"
      />
    </div>
    <!-- <HistoryItem :footyStats="footyStats"/> -->
    <div class="as-team-history">
      <div class="as-team-history__item">
        <TeamItem
          teamMode="home"
          :footyStats="footyStats"
          :homeTeamInfo="homeTeamInfo"
          :awayTeamInfo="awayTeamInfo"
        />
        <StaticsTeam
          teamMode="home"
          :footyStats="footyStats"
          :homeTeamInfo="homeTeamInfo"
          :awayTeamInfo="awayTeamInfo"
        />
      </div>
    </div>
    <div class="as-team-history as-none-border">
      <div class="as-team-history__item">
        <TeamItem
          teamMode="away"
          :footyStats="footyStats"
          :homeTeamInfo="homeTeamInfo"
          :awayTeamInfo="awayTeamInfo"
        />
        <StaticsTeam
          teamMode="away"
          :footyStats="footyStats"
          :homeTeamInfo="homeTeamInfo"
          :awayTeamInfo="awayTeamInfo"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import FootballTeamItem from "../FootballTeamItem.vue";
import IconPerformance from "~src/components/icons/foot_stats/IconPerformance.vue";
import TeamItem from "./TeamItem.vue";
import StaticsTeam from "./StaticsTeam.vue";
import IBall from "~src/components/icons/incident/IBall.vue";
import type { IFootyStats, ITeam, IStatsParent } from "~src/interfaces/footystats";
import { getPercentByPoint } from "~src/helpers/footystats";

interface Props {
  match: IMatch;
  modifyClass?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

const props = withDefaults(defineProps<Props>(), {
  modifyClass: "",
  footyStats: null,
});

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const homePoint = computed<number>(() => {
  return homeTeamLastX.value?.stats?.seasonPPG_overall ?? 0;
});

const awayPoint = computed<number>(() => {
  return awayTeamLastX.value?.stats?.seasonPPG_overall ?? 0;
});
</script>

<script lang="ts">
export default {};
</script>
